export const AppConfig = {
  apiBaseURL: "https://azapp-signup-portal-service-prod-001.azurewebsites.net",  
  accountName: "alchemydev001", 
  containerName: "signup-portal",
  encodeKey: 'secret key 123',
  logoutRedirectUrl: "https://AlchemyVisionDev.b2clogin.com/AlchemyVisionDev.onmicrosoft.com/B2C_1_LoginFlow/oauth2/v2.0/logout?post_logout_redirect_uri=https://internal.alchemyvision.com/",
} ;
  